import React, { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Trash2, CheckCircle2, RotateCcw, Mail } from "lucide-react";

export const IssuesSection = () => {
  const [rows, setRows] = useState([]);
  const load = () => adminApi.issues().then(setRows);
  useEffect(() => { load(); }, []);

  const toggle = async (it) => {
    const status = it.status === "open" ? "resolved" : "open";
    await adminApi.updateIssue(it.id, { status }); toast.success(`Marked ${status}`); load();
  };
  const del = async (id) => { if (!window.confirm("Delete this submission?")) return; await adminApi.deleteIssue(id); toast.success("Deleted"); load(); };

  return (
    <div>
      <h2 className="mb-5 font-serif text-2xl font-semibold text-gmoaa-green">Contact / Issue Submissions ({rows.length})</h2>
      {rows.length === 0 && <p className="text-gmoaa-text-muted">No submissions yet.</p>}
      <div className="space-y-2">
        {rows.map((it) => (
          <div key={it.id} className="rounded-xl border border-gmoaa-border-subtle bg-white p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="flex flex-wrap items-center gap-2 font-medium text-gmoaa-text-dark">
                  {it.subject}
                  <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${it.status === "open" ? "bg-gmoaa-saffron-light text-gmoaa-saffron-hover" : "bg-gmoaa-green-light text-gmoaa-green"}`}>{it.status}</span>
                  <span className="rounded bg-gmoaa-surface px-1.5 py-0.5 text-[10px] text-gmoaa-text-muted">{it.category}</span>
                </p>
                <p className="mt-1 text-sm text-gmoaa-text-muted">{it.message}</p>
                <p className="mt-2 text-xs text-gmoaa-text-muted">
                  {it.name}{it.district ? ` · ${it.district}` : ""}{it.mobile ? ` · ${it.mobile}` : ""}{it.email ? ` · ${it.email}` : ""}
                </p>
              </div>
              <div className="flex shrink-0 gap-1">
                <Button size="sm" variant="ghost" onClick={() => toggle(it)} title="Toggle status">
                  {it.status === "open" ? <CheckCircle2 size={15} className="text-gmoaa-green" /> : <RotateCcw size={15} />}
                </Button>
                <Button size="sm" variant="ghost" className="text-gmoaa-red" onClick={() => del(it.id)}><Trash2 size={15} /></Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
